<template>
  <div class="con" v-loading="loading">
    <div class="box-card">
      <div class="text item">
        <!-- <network-info :network-info="networkInfo"></network-info>
        <div class="setting">功能配置</div> -->
        <el-divider content-position="left">
          {{ $t("lang.ConfigSetting.WebAccess") }}&nbsp;--&nbsp;{{
            $t("lang.ConfigSetting.Changes")
          }}</el-divider>
        <div class="Table-Con">
          <el-form ref="ruleForms" :rules="rules" :model="data" label-width="250px" class="demo-ruleForm">
            <el-form-item :label="`${$t('lang.ConfigSetting.Port')}：`" prop="listen_http">
              <el-input size="mini" class="Form-Input-Width" v-model="data.listen_http"></el-input>
            </el-form-item>
            <el-form-item :label="$t('lang.ConfigSetting.disabledAccess')">
              <el-checkbox v-model="data._dropWanWeb.state"></el-checkbox>
              <p class="tips">不能以默认密码在Web上访问设备</p>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="text item">
        <el-divider content-position="left">
          {{ $t("lang.ConfigSetting.SSHAccess") }}
          &nbsp;--&nbsp;
          {{ $t("lang.ConfigSetting.Dropbear") }}
        </el-divider>
        <el-table style="margin-top: 50px" :data="data.s_objects" border strip>
          <el-table-column :label="`${$t('lang.ConfigSetting.Interface')}`">
            <template slot-scope="scope">
              <el-select :placeholder="$t('lang.ConfigSetting.pleaseChoose')" v-model="scope.row.options.Interface"
                class="Form-Input-Width" size="mini">
                <el-option v-for="item in DropbearSelect" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column :label="`${$t('lang.ConfigSetting.Port')}`">
            <template slot-scope="scope">
              <el-input size="mini" class="Form-Input-Width" v-model="scope.row.options.Port"></el-input>
            </template>
          </el-table-column>
          <el-table-column :label="`${$t('lang.ConfigSetting.Passwordauthentication')}`">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.options.PasswordAuth"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column :label="`${$t('lang.ConfigSetting.withpassword')}`">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.options.RootPasswordAuth"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column :label="`${$t('lang.ConfigSetting.Gatewayports')}`">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.options.GatewayPorts"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column :label="$t('lang.Button.operation')">
            <template slot-scope="scope">
              <el-button type="danger" size="small" @click="DeleteOptions(scope.row, scope.$index)">
                {{ $t("lang.ConfigSetting.delete") }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-button type="primary" size="small" class="Add-Buttom" @click="AddOptions">
        {{ $t("lang.ConfigSetting.ADD") }}</el-button>
      <el-button size="mini" @click="updateConfig" type="danger" class="Config-Buttom">
        {{ $t("lang.ConfigSetting.SaveApply") }}
      </el-button>
    </div>
  </div>
</template>
<script>
import {
  updateConfig,
  listConfig,
  getNetworkInfo,
} from "@/api/configurationlist";
import { cloneDeep, isEqual } from "lodash";
import { compareVersion } from "@/utils/Date";
// import networkInfo from '../networkInfo/index'
export default {
  props: ["deviceDid", "deviceSn", "deviceSoftwareVer"],
  // components: {
  //   networkInfo
  // },
  data() {
    var port = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入端口"));
      } else if (
        /^([0-9]|[1-9]\d|[1-9]\d{2}|[1-9]\d{3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/.test(
          value
        )
      ) {
        callback();
      } else {
        return callback(new Error("请输入正确的端口"));
      }
    };
    return {
      checked: true,
      DropbearSelect: [
        { label: this.$t("lang.ConfigSetting.unspecified"), value: "" },
        { label: "WAN", value: "wan" },
        { label: "LAN", value: "lan" },
      ],
      loading: true,
      //控制dom更新的生命周期操作
      UpData: true,
      data: {
        listen_http: "",
        _dropWanWeb: {

        },
      },
      rules: {
        listen_http: [{ validator: port, trigger: "change" }],
      },
      WatchData: {},
      // 待删除数据
      deleteOptions: {
        section: "dropbear",
        config: "dropbear",
        server: "dropbear",
        action: 2,
        index: [], // 删除数据索引数组
      },
      // 网络接口基本信息
      networkInfo: {},
    };
  },
  watch: {
    deviceSn: {
      immediate: true,
      handler(newValue, oldValue) {
        this.getConfig();
        // this.fetchNetworkInfo()
      },
    },
  },
  methods: {
    // 获取配置参数
    getConfig() {
      this.loading = true;
      console.log(this.deviceSoftwareVer);
      this.deleteOptions = {
        section: "dropbear",
        config: "dropbear",
        server: "dropbear",
        action: 2,
        index: [],
      };
      if (compareVersion(this.deviceSoftwareVer, "v2.4.220501") == -1) {
        listConfig(this.deviceSn, this.deviceDid, [
          {
            section: "main",
            config: "uhttpd",
            options: [{ option: "listen_http" }, { option: "_dropWanWeb" }],
          },
          {
            section: "dropbear",
            config: "dropbear",
            options: [
              { option: "PasswordAuth" },
              { option: "Port" },
              { option: "RootPasswordAuth" },
              { option: "GatewayPorts" },
              { option: "Interface" },
            ],
          },
        ])
          .then((res) => {
            const data = res.data.data.mess;
            //筛选参数
            this.$set(
              this.data,
              "listen_http",
              data[0].s_objects[0].options.listen_http
                ? data[0].s_objects[0].options.listen_http.split(":")[1]
                  ? data[0].s_objects[0].options.listen_http.split(":")[1]
                  : "80"
                : "80"
            );
            this.$set(this.data, "s_objects", data[1].s_objects);
            this.data.s_objects.forEach((val, index) => {
              if (!val.options.Interface) {
                this.$set(this.data.s_objects[index].options, "Interface", "");
              }
              if (val.options.PasswordAuth == "on") {
                this.$set(
                  this.data.s_objects[index].options,
                  "PasswordAuth",
                  true
                );
              } else if (
                !val.options.PasswordAuth ||
                val.options.PasswordAuth == "off"
              ) {
                this.$set(
                  this.data.s_objects[index].options,
                  "PasswordAuth",
                  false
                );
              }
              if (val.options.GatewayPorts == "on") {
                this.$set(
                  this.data.s_objects[index].options,
                  "GatewayPorts",
                  true
                );
              } else if (
                !val.options.GatewayPorts ||
                val.options.GatewayPorts == "off"
              ) {
                this.$set(
                  this.data.s_objects[index].options,
                  "GatewayPorts",
                  false
                );
              }
              if (val.options.RootPasswordAuth === "off") {
                this.$set(
                  this.data.s_objects[index].options,
                  "RootPasswordAuth",
                  false
                );
              } else {
                console.log("on");
                this.$set(
                  this.data.s_objects[index].options,
                  "RootPasswordAuth",
                  true
                );
              }
            });
            this.WatchData = cloneDeep(this.data);
            this.loading = false;
          })
          .catch((err) => {
            this.$message({
              message: this.$t("lang.request.timeout"),
              type: "warning",
            });
          });
      } else {
        let o = {};
        if (compareVersion(this.deviceSoftwareVer, "v2.9.250416") == -1) {
          o = {
            section: "rule",
            config: "firewall",
            options: [
              {
                option: "enabled",
              },
              {
                option: "name",
              },
              {
                option: "target",
              }
            ]
          };
        } else {
          o = {
            section: "webctrl",
            config: "firewall",
            options: [
              {
                option: "enabled",
              },
            ]
          };
        }
        listConfig(this.deviceSn, this.deviceDid, [
          {
            section: "main",
            config: "uhttpd",
            lists: [{ list: "listen_http" }],
            // options: [{ option: "_dropWanWeb" }],
          },
          {
            section: "dropbear",
            config: "dropbear",
            options: [
              { option: "PasswordAuth" },
              { option: "Port" },
              { option: "RootPasswordAuth" },
              { option: "GatewayPorts" },
              { option: "Interface" },
            ],
          },
          o
        ])
          .then((res) => {
            const data = res.data.data.mess;
            if (compareVersion(this.deviceSoftwareVer, "v2.9.250416") == -1) {
              let _dropWanWeb = {};
              const rule = data[2].s_objects;
              if (rule instanceof Array) {
                let w = rule.find(item => item.options.name === "Drop-WAN-Web")
                if (w) {
                  _dropWanWeb = {
                    index: w.index,
                    state: (w.options.enabled === "1" && w.options.target !== 'ACCEPT')
                  }
                }
              }
              this.data._dropWanWeb = _dropWanWeb
            } else {
              const webctrl = data[2].s_objects[0];
              this.data._dropWanWeb = {
                index: webctrl.index,
                state: webctrl.options.enabled !== "0"
              }
            }
            //筛选参数
            this.$set(
              this.data,
              "listen_http",
              data[0].s_objects[0].lists.listen_http
                ? data[0].s_objects[0].lists.listen_http[0].split(":")[1]
                  ? data[0].s_objects[0].lists.listen_http[0].split(":")[1]
                  : "80"
                : "80"
            );
            this.$set(this.data, "s_objects", data[1].s_objects);
            this.data.s_objects.forEach((val, index) => {
              if (!val.options.Interface) {
                this.$set(this.data.s_objects[index].options, "Interface", "");
              }
              if (val.options.PasswordAuth == "on") {
                this.$set(
                  this.data.s_objects[index].options,
                  "PasswordAuth",
                  true
                );
              } else if (
                !val.options.PasswordAuth ||
                val.options.PasswordAuth == "off"
              ) {
                this.$set(
                  this.data.s_objects[index].options,
                  "PasswordAuth",
                  false
                );
              }
              if (val.options.GatewayPorts == "on") {
                this.$set(
                  this.data.s_objects[index].options,
                  "GatewayPorts",
                  true
                );
              } else if (
                !val.options.GatewayPorts ||
                val.options.GatewayPorts == "off"
              ) {
                this.$set(
                  this.data.s_objects[index].options,
                  "GatewayPorts",
                  false
                );
              }
              if (val.options.RootPasswordAuth === "off") {
                console.log("off");
                this.$set(
                  this.data.s_objects[index].options,
                  "RootPasswordAuth",
                  false
                );
              } else {
                console.log("on");
                this.$set(
                  this.data.s_objects[index].options,
                  "RootPasswordAuth",
                  true
                );
              }
            });
            this.WatchData = cloneDeep(this.data);
            this.loading = false;
          })
          .catch((err) => {
            this.$message({
              message: this.$t("lang.request.timeout"),
              type: "warning",
            });
          });
      }
    },
    // 获取lan接口基本信息
    // fetchNetworkInfo() {
    //   getNetworkInfo(this.deviceDid, this.deviceSn, ['system']).then(res => {
    //     this.networkInfo = res.data.data.mess.system
    //   })
    // },
    //添加新的规则
    AddOptions() {
      this.data.s_objects.push({
        action: 1,
        options: {
          Port: "402",
          Interface: "",
          PasswordAuth: true,
          RootPasswordAuth: true,
        },
      });
    },
    //删除规则
    DeleteOptions(row, index) {
      if (row.action === 1) {
        // 新添加暂未保存直接删除
        this.data.s_objects.splice(index, 1);
      } else {
        // 已经存在设备里的，则先存进待删除数组中再删除
        this.deleteOptions.index.push(index);
        console.log(this.deleteOptions);
        this.data.s_objects.splice(index, 1);
      }
    },
    //修改
    updateConfig() {
      //生命周期不转换复选框
      this.UpData = false;
      if (!isEqual(this.data, this.WatchData)) {
        let submitData = cloneDeep(this.data);
        // 把待删除数据一并传给后端
        let data = [];
        submitData.s_objects.forEach((item, index) => {
          let obj = cloneDeep(item);
          obj.options.PasswordAuth = obj.options.PasswordAuth ? "on" : "off";
          obj.options.GatewayPorts = obj.options.GatewayPorts ? "on" : "off";
          obj.options.RootPasswordAuth = obj.options.RootPasswordAuth
            ? "on"
            : "off";
          obj.action = obj.action ? obj.action : 0;
          data.push({
            section: "dropbear",
            config: "dropbear",
            server: "dropbear",
            action: obj.action,
            index: [index],
            options: { ...obj.options },
          });
        });

        if (this.deleteOptions.index.length > 0) {
          data.unshift(this.deleteOptions);
        }
        if (compareVersion(this.deviceSoftwareVer, "v2.4.220501") == -1) {
          updateConfig(this.deviceSn, this.deviceDid, [
            {
              section: "main",
              config: "uhttpd",
              action: 0,
              index: [0],
              server: "uhttpd",
              options: {
                listen_http: "0.0.0.0:" + this.data.listen_http,
              },
            },
            ...data,
          ]).then((res) => {
            if (res.data.data.mess === 0) {
              this.$message({
                showClose: true,
                message: this.$t("lang.ConfigSetting.Successfulconfiguration"),
                type: "success",
              });
              this.getConfig();
              // this.fetchNetworkInfo()
            } else {
              this.$message({
                showClose: true,
                message: this.$t("lang.ConfigSetting.Configurationerror"),
                type: "warning",
              });
              //释放update生命周期钩子更新
              this.getConfig();
              return;
            }
          });
        } else {
          let s = {};
          if (compareVersion(this.deviceSoftwareVer, "v2.9.250416") == -1) {
            s = {
              section: 'rule',
              config: 'firewall',
              action: 0,
              index: [this.data._dropWanWeb.index],
              server: "firewall",
              options: {
                enabled: this.data._dropWanWeb.state ? '1' : '0',
                target: this.data._dropWanWeb.state ? 'REJECT' : 'ACCEPT',
              },
            }
          } else {
            s = {
              section: 'webctrl',
              config: 'firewall',
              action: 0,
              index: [this.data._dropWanWeb.index],
              server: "firewall",
              options: {
                enabled: this.data._dropWanWeb.state ? '1' : '0'
              },
            }
          }
          updateConfig(this.deviceSn, this.deviceDid, [
            {
              section: "main",
              config: "uhttpd",
              action: 0,
              index: [0],
              server: "uhttpd",
              // options: {
              //   listen_http: "0.0.0.0:" + this.data.listen_http,
              // },
              lists: {
                listen_http: ["0.0.0.0:" + this.data.listen_http],
              },
            },
            s,
            ...data,
          ]).then((res) => {
            if (res.data.data.mess === 0) {
              this.$message({
                showClose: true,
                message: this.$t("lang.ConfigSetting.Successfulconfiguration"),
                type: "success",
              });
              this.getConfig();
              // this.fetchNetworkInfo()
            } else {
              this.$message({
                showClose: true,
                message: this.$t("lang.ConfigSetting.Configurationerror"),
                type: "warning",
              });
              //释放update生命周期钩子更新
              this.getConfig();
              return;
            }
          });
        }
      } else {
        this.$message({
          showClose: true,
          message: this.$t("lang.ConfigSetting.Nochangesmade"),
          type: "warning",
        });
        return;
      }
    },
  },
};
</script>
<style scoped>
.title {
  margin: 15px;
}

.Label-Text {
  font-size: 14px;
  color: #909399;
}

.Delete-Buttom {
  margin-right: 10%;
  margin-left: 80%;
}

.Add-Buttom {
  margin-bottom: 1rem;
}

.tips {
  font-size: 14px;
  color: #909399;
}
</style>
<style src="../common.css" scoped></style>
